import { FileAccept } from "../types/files";

const fontOptions = [
  {
    label: "Sans Serif",
    value: "sans-serif",
    style: { fontFamily: "sans-serif" },
  },
  { label: "Serif", value: "serif", style: { fontFamily: "serif" } },
  {
    label: "Fixed Width",
    value: "monospace",
    style: { fontFamily: "monospace" },
  },
  {
    label: "Wide",
    value: "wide",
    style: { fontWeight: "bold", letterSpacing: "0.05em" },
  },
  { label: "Narrow", value: "narrow", style: { fontStretch: "condensed" } },
  {
    label: "Comic Sans MS",
    value: "Comic Sans MS",
    style: { fontFamily: "Comic Sans MS, cursive" },
  },
  {
    label: "Garamond",
    value: "Garamond",
    style: { fontFamily: "Garamond, serif" },
  },
  {
    label: "Georgia",
    value: "Georgia",
    style: { fontFamily: "Georgia, serif" },
  },
  {
    label: "Tahoma",
    value: "Tahoma",
    style: { fontFamily: "Tahoma, sans-serif" },
  },
  {
    label: "Trebuchet MS",
    value: "Trebuchet MS",
    style: { fontFamily: "Trebuchet MS, sans-serif" },
  },
  {
    label: "Verdana",
    value: "Verdana",
    style: { fontFamily: "Verdana, sans-serif" },
  },
];
export const OPTIONS = [
  { key: "small", label: "Small", sizePx: 12, htmlNodeVal: "2" },
  { key: "normal", label: "Normal", sizePx: 18, htmlNodeVal: "4" },
  { key: "large", label: "Large", sizePx: 28, htmlNodeVal: "6" },
  { key: "huge", label: "Huge", sizePx: 56, htmlNodeVal: "7" },
];
export const GREYS = [
  "#000000",
  "#3a3a3a",
  "#5a5a5a",
  "#8a8a8a",
  "#bfbfbf",
  "#dedede",
  "#f3f3f3",
  "#ffffff",
];
export const ACCENTS = [
  "#e53935",
  "#fb8c00",
  "#ffee58",
  "#66ff66",
  "#4dd0e1",
  "#1e88e5",
  "#9c27b0",
  "#ff3bd6",
];
// a multi-row palette (example block similar to screenshot)
export const PALETTE = [
  [
    "#f7d7d7",
    "#f3d0c8",
    "#f0c5c5",
    "#efc9d8",
    "#f7e6e9",
    "#f3edf7",
    "#f0eaf6",
    "#f8f0f6",
  ],
  [
    "#f0b9b9",
    "#f0d4c2",
    "#e6f0d2",
    "#e4f7e8",
    "#d8eef8",
    "#dbe1ff",
    "#e9d9f6",
    "#f5d9f7",
  ],
  [
    "#e69a9a",
    "#e6caa3",
    "#d7e6b0",
    "#c8f0e6",
    "#bfe3ff",
    "#cbd8ff",
    "#d6c3f3",
    "#f0c2f3",
  ],
  [
    "#d16464",
    "#d09a6a",
    "#a8cf7b",
    "#7fd6c0",
    "#73b7ff",
    "#7a9cff",
    "#b483f1",
    "#f08cf2",
  ],
  [
    "#b23a3a",
    "#b26a3a",
    "#7aa04a",
    "#3fb092",
    "#296f94",
    "#2a4177",
    "#452a68",
    "#6e1f4d",
  ],
  [
    "#7a1d1d",
    "#7a4a1e",
    "#556a2a",
    "#195b47",
    "#123f5a",
    "#182840",
    "#2a1836",
    "#3a1026",
  ],
];
export default fontOptions;

export const ImageFileAccept: FileAccept = {
  "image/*": [".png", ".gif", ".jpeg", ".jpg", ".webp"],
};

export const StrictImageFileAccept: FileAccept = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
};

export const TextFileAccept: FileAccept = {
  "text/plain": [".txt"],
};

export const CsvFileAccept: FileAccept = {
  "text/csv": [".csv"],
  "application/vnd.ms-excel": [".csv"],
};

export const PdfFileAccept: FileAccept = {
  "application/pdf": [".pdf"],
};

export const WordFileAccept: FileAccept = {
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};

export const ExcelFileAccept: FileAccept = {
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};

export const PptFileAccept: FileAccept = {
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
};

export const OdfFileAccept: FileAccept = {
  "application/vnd.oasis.opendocument.text": [".odt"],
  "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
};

export const AudioFileAccept: FileAccept = {
  "audio/mpeg": [".mp3"],
  "audio/mp4": [".m4a"],
  "audio/x-wav": [".wav"],
  "audio/ogg": [".ogg"],
  "audio/webm": [".weba"],
};

export const VideoFileAccept: FileAccept = {
  "video/mp4": [".mp4"],
  "video/quicktime": [".mov"],
  "video/webm": [".webm"],
};

export const FILE_KEYS = {
  CSV: "csv",
  DOC: "doc",
  DOCX: "docx",
  PDF: "pdf",
  PNG: "png",
  ZIP: "zip",
  XLS: "xls",
  XLSX: "xlsx",
  EXE: "exe",
  JPG: "jpg",
  JPEG: "jpeg",
  WEBP: "webp",
} as const;

export const FILE_CONFIG = {
  [FILE_KEYS.PDF]: {
    icon: "Pdf",
    label: "PDF",
  },
  [FILE_KEYS.CSV]: {
    icon: "Csv",
    label: "CSV",
  },
  [FILE_KEYS.XLS]: {
    icon: "Xls",
    label: "Excel",
  },
  [FILE_KEYS.XLSX]: {
    icon: "Xlsx",
    label: "Excel",
  },
  [FILE_KEYS.DOC]: {
    icon: "Doc",
    label: "Word",
  },
  [FILE_KEYS.DOCX]: {
    icon: "Doc",
    label: "Word",
  },
  [FILE_KEYS.JPG]: {
    icon: "Jpg",
    label: "Image",
  },
  [FILE_KEYS.JPEG]: {
    icon: "Jpg",
    label: "Image",
  },
  [FILE_KEYS.PNG]: {
    icon: "Png",
    label: "Image",
  },
  [FILE_KEYS.WEBP]: {
    icon: "Bmp",
    label: "Image",
  },
  [FILE_KEYS.ZIP]: {
    icon: "Zip",
    label: "Image",
  },
  [FILE_KEYS.EXE]: {
    icon: "Exe",
    label: "Image",
  },
  default: {
    icon: "File",
    label: "File",
  },
} as const;
